document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.external-variants-row').forEach(swatchContainer => {
    swatchContainer.addEventListener('click', event => {
      const swatch = event.target.closest('.product-color');
      if (!swatch) return;

      event.preventDefault();

      const card = swatch.closest('.product-card-wrapper');
      if (!card) return;

      const newImage = swatch.dataset.img;
      const newVariantId = swatch.dataset.variantId;
      const productUrl = swatchContainer.dataset.productUrl;

      // Update main image
      const imageElement = card.querySelector('.card__media img');
      if (imageElement && newImage) {
        imageElement.src = newImage;
        imageElement.srcset = newImage;
      }

      // Update product link
      const productLink = card.querySelector('.full-unstyled-link');
      if (productLink && newVariantId) {
        productLink.href = `${productUrl}?variant=${newVariantId}`;
      }

      // Update active swatch
      swatchContainer.querySelectorAll('.product-color').forEach(s => s.classList.remove('active-swatch'));
      swatch.classList.add('active-swatch');

      // (Optional) Update price - This part would need more complex logic
      // to fetch the variant price. For now, we are just updating the image
      // and the main link.
    });
  });
}); 